import BaseController       from "controllers/base"
import { placesUri }        from "servos/googlePlaces"

import GeocompletedAddress  from 'widgets/geocompletedAddress'
import NewProjectForm       from 'widgets/project/newForm';

class Controller extends BaseController {
  call() {
    bindCustomWorkDescriptions.call(this)
    bindProjectType.call(this);
    bindRemoveClient.call(this);
    new NewProjectForm(this.root);
    bindBuilderType.call(this)
    bindBuilderTypeSelected.call(this)
    bindZoning.call(this)
  }

  scripts() {
    return [placesUri]
  }
};

let bindCustomWorkDescriptions = function() {
  this.root.find('.works-description').on('change', (e) => {
    toggleAdditionalWorksDescription.call(this, e.currentTarget.value)
  })
}

let toggleAdditionalWorksDescription = function(value) {
  if (value == 'custom') {
    this.root.find('.additional-works-description').removeClass('d-none')
    this.root.find('.additional-works-description input').prop('disabled', false)
  } else {
    this.root.find('.additional-works-description').addClass('d-none')
    this.root.find('.additional-works-description input').prop('disabled', true)
  }
}

const bindProjectType = function() {
  this.root.find('.submit-checklist-template').on('click', (e) => {
    let selected = this.root.find('.select-checklist').val()
    console.log(selected);
    this.root.find("input.project-type").val(selected)
    this.root.find("form").submit()
  })
}

let bindRemoveClient = function() {
  this.root.find('.remove-client-btn').on('click', (e) => {
    let removalUrl = e.currentTarget.dataset.url
    swal({
      title: "Are you sure you want to remove this client?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: `Sure`,
    }).then((confirm) => {
      if (confirm.value === true) {
        $.ajax({
          url: removalUrl,
          method: "PUT",
          dataType: "json"
        }).done(() => {
          location.reload()
        })
      }
    })
  })
}

let bindBuilderTypeSelected = function() {
  let selected = this.root.find('.builder-type').val()
  if (selected == 'contractor_unlicensed') {
    $('.builder-details').removeClass('d-none')
  }
}

let bindZoning = function() {
  this.root.find('#new_project_form_zoning').on('change', (e) => {
    let selected = e.currentTarget.value
    if (selected == 'custom') {
      $('.custom-zoning').removeClass('d-none')
    } else {
      $('.custom-zoning').addClass('d-none')
    }
  })
}

let bindBuilderType = function() {
  this.root.find('.builder-type').on('change', (e) => {
    let selected = e.currentTarget.value
    if (selected == 'contractor_unlicensed') {
      $('.builder-details').addClass('d-none')
      $('#new_project_form_licence').val('')
    } else {
      $('.builder-details').removeClass('d-none')
    }
  })
}

export default Controller;
